export default __webpack_public_path__ + "static/media/Magical Strings 2018 (208 of 264).2773303f.jpg";